/** Copy the original value; never report success when the browser rejects it. */
export async function copyText(value: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value)
    return
  }

  const previousFocus = document.activeElement
  const input = document.createElement("textarea")
  input.value = value
  input.readOnly = true
  input.style.cssText = "position:fixed;top:0;left:0;opacity:0;pointer-events:none"
  document.body.appendChild(input)
  try {
    input.select()
    if (!document.execCommand("copy")) throw new Error("Clipboard unavailable")
  } finally {
    input.remove()
    if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true })
  }
}
